/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExistingPublicKeyCredential interface.
 */
export function instanceOfExistingPublicKeyCredential(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('opensshPublicKey' in value) || value['opensshPublicKey'] === undefined)
        return false;
    return true;
}
export function ExistingPublicKeyCredentialFromJSON(json) {
    return ExistingPublicKeyCredentialFromJSONTyped(json, false);
}
export function ExistingPublicKeyCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': json['label'],
        'dateAdded': json['date_added'] == null ? undefined : (new Date(json['date_added'])),
        'lastUsed': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'opensshPublicKey': json['openssh_public_key'],
    };
}
export function ExistingPublicKeyCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': value['label'],
        'date_added': value['dateAdded'] == null ? undefined : ((value['dateAdded']).toISOString()),
        'last_used': value['lastUsed'] == null ? undefined : ((value['lastUsed']).toISOString()),
        'openssh_public_key': value['opensshPublicKey'],
    };
}
